import { LevelData } from '../level-data';

export const level7: LevelData = {
    name: 'Gap Challenge',
    timeLimit: 80,
    track: [
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '-------',
        '---  --',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '--  ---',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '---  --',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        'FFFFFFF',
    ],
};
